import AvatarPlaceholder from 'assets/images/avatar_placeholder.png';
import { IconManager } from 'components/_universal/IconManager/IconManager';
import { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import LocalStorageManager from 'services/LocalStorageManager/LocalStorageManager';
import paths from 'shared/paths';
import { useAuthMeQuery, useLogoutMutation } from 'src/graphql/generated';
import { useOnClickOutside } from 'utils/hooks';
import {
    ProfileDropdownListItem,
    ProfileDropdownListWrapper,
    ProfileDropdownLogutItem,
    ProfileDropdownName,
    ProfileDropdownTextWrapper,
    ProfileDropdownTitle,
    ProfileDropdownWrapper,
    ProfileImage,
} from './ProfileDropdown.styled';

export const ProfileDropdown = () => {
    const [isProfileDropDownOpen, setIsProfileDropDownOpen] = useState(false);
    const history = useHistory();
    const ref = useRef<HTMLDivElement>(null);

    const [logOut] = useLogoutMutation();

    const { data } = useAuthMeQuery({
        fetchPolicy: 'cache-and-network',
        onError: (error) => {
            if (error.message === 'Session not found') {
                history.push(paths.login);
                LocalStorageManager.clear();
            }
        },
    });

    const user = data?.me;

    const onClose = () => {
        setIsProfileDropDownOpen(false);
    };

    const onLogOut = () => {
        logOut({
            onCompleted: () => {
                history.push(paths.login);
                LocalStorageManager.clear();
            },
        });
    };

    useOnClickOutside(ref, onClose);

    return (
        <ProfileDropdownWrapper
            onClick={() => setIsProfileDropDownOpen(!isProfileDropDownOpen)}
            ref={ref}
        >
            <ProfileImage src={user?.avatar ?? AvatarPlaceholder} />
            <ProfileDropdownTextWrapper>
                <ProfileDropdownName>{user?.name}</ProfileDropdownName>
                <ProfileDropdownTitle>{user?.role}</ProfileDropdownTitle>
            </ProfileDropdownTextWrapper>
            <IconManager
                cursorPointer
                name={'ArrowWhite'}
                rotate={isProfileDropDownOpen ? 180 : 0}
            />
            {isProfileDropDownOpen && (
                <ProfileDropdownListWrapper>
                    {/* <ProfileDropdownListItem to={paths.profile}>
                        <IconManager
                            cursorPointer
                            name={'ProfileIcon'}
                            size={20}
                        />
                        profil
                    </ProfileDropdownListItem> */}
                    <ProfileDropdownListItem to={paths.home}>
                        <IconManager
                            cursorPointer
                            name={'MainPanelIcon'}
                            size={20}
                        />
                        panel główny
                    </ProfileDropdownListItem>
                    <ProfileDropdownLogutItem onClick={() => onLogOut()}>
                        <IconManager
                            cursorPointer
                            name={'LogoutIcon'}
                            size={20}
                        />
                        wyloguj się
                    </ProfileDropdownLogutItem>
                </ProfileDropdownListWrapper>
            )}
        </ProfileDropdownWrapper>
    );
};
